import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Button, Paper } from '@material-ui/core';

import Facebook from "./images/TE.png"
import Instagram from "./images/INSE.png"
import Twitter from "./images/TWE.png"

import LOGO from "./images/K-Brielly logo.png"

import Snackbar from "./CustomizedSnackbar";

import * as emailjs from 'emailjs-com'
import{ init } from 'emailjs-com';
init("user_P2eqMtHWEbMkhilx8tgCG");


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    color: "#F5F5F5",
    backgroundColor:"#1a1818",
    borderRadius:0,
    fontSize:"14px",
    fontFamily:"Arial Narrow",
    
  },
  about:{
      color:"#FFF",
      fontSize:"12px",
      letterSpacing:"1px",
      textTransform:"uppercase",
      textAlign:"start",
      padding: theme.spacing(2),
      backgroundColor:"#696a68",
      marginLeft:20
  }
  ,
  theList:{
      textAlign:"start",
      
  },
  rights:{
    textAlign:"center",
    
},
  contact:{
    color:"#FFF",
    fontSize:"12px",
    letterSpacing:"2px",
    textTransform:"uppercase",
    textAlign:"center",
    padding: theme.spacing(2)
}
,
media:{
  color:"#FFF",
  fontSize:"12px",
  letterSpacing:"2px",
  textTransform:"uppercase",
  textAlign:"start",
  padding: theme.spacing(2)
},
links:{
    color:"#FFF",
    fontSize:"12px",
    letterSpacing:"2px",
    textTransform:"uppercase",
    textAlign:"start",
    padding: theme.spacing(2)
},
LinkList:{
    textAlign:"start",
},
btn:{
  color:"#FFF"
}

}));

export default function FullWidthGrid() {
  const classes = useStyles();
  const [email, setEmail]=useState("");
  const [subject, setSubject]=useState("");
  const [message, setMessage]=useState("");

  const [snackbarMessage, setsnackbarMessage] = useState();
  const [snackbarVariant, setsnackbarVariant] = useState();
  const [snackbarTrigger, setsnackbarTrigger] = useState();

  const triggerSnackbar = (message, variant) => {
    setsnackbarMessage(message);
    setsnackbarVariant(variant);
    setsnackbarTrigger(true);
  };

  const onSnackbarClose = () => {
    setsnackbarTrigger(false);
  };

 const handleEChange = (e) => {
   setEmail(e.target.value);
}
const handleSChange = (e) => {
  setSubject(e.target.value);
}
const handleMChange = (e) => {
  setMessage(e.target.value);
}

const handleSubmit=(e)=>{
  e.preventDefault()
  
   emailjs.send("service_p4vmfho","template_7ge57x7",{
    from_name: email,
    to_name: "K-Brielly",
    message: message,
    subject: subject
    });
  
    triggerSnackbar("Email sent","success");
    setEmail("");
    setSubject("");
    setMessage("");
}

  return (
    <div className={classes.root}>
      <Grid container className={classes.paper}>
      <Snackbar
          message={snackbarMessage}
          trigger={snackbarTrigger}
          variant={snackbarVariant}
          onClose={onSnackbarClose}
        />
            <Grid container justify="center" >
              <Grid item xs={12} sm={4} >
                <Paper elevation={20} className={classes.about}>
                    <h4>Get in touch</h4>
                    Email Address<br/><br/>
                    <TextField
                    className={classes.txtFields}
                     variant="outlined"
                     style={{background:"#FFF"}}
                     id="email"
                     size="small"
                     placeholder="Enter your email"
                     type="text"
                     fullWidth
                     onChange={handleEChange}
                     value={email}
                     /><br/><br/>
                    Subject<br/><br/>
                    <TextField
                     variant="outlined"
                     id="subject"
                     style={{background:"#FFF"}}
                     size="small"
                     placeholder="Subject"
                     type="text"
                     fullWidth
                     onChange={handleSChange}
                     value={subject}
                     /><br/><br/>
                    Message<br/><br/>
                    <TextField
                     variant="outlined"
                     id="message"
                     size="small"
                     style={{background:"#FFF"}}
                     placeholder="Message"
                     type="text"
                     multiline
                     fullWidth
                     onChange={handleMChange}
                     value={message}
                     /><br/><br/>
                     <Button
                     fullWidth
                     className={classes.btn}
                      variant="outlined"
                      onClick={handleSubmit}
                      >SEND</Button>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.contact}>
                    <h4 >Contact info</h4><br/>
                    
                      Cell number 1: (+267) 74 369 947<br/><br/>
                      Cell number 2: (+267) 73 319 835<br/><br/>
                      <span style={{textTransform:"lowercase",fontSize:16}}>kbriellymokgadi@gmail.com</span>
                    
                    <h4>Connect with us on social media</h4>
                        <a style={{marginRight:10}} href="https://facebook.com/kbrielly">
                          <img alt="Facebook logo" src={Facebook} height={30}  />
                        </a>
                        <a style={{marginRight:10}} href="https://instagram.com/_kbrielly">
                          <img alt="Instagram logo" src={Instagram} height={30}  />
                        </a>
                        <a style={{marginRight:10}} href="https://twitter.com/_kbrielly">
                          <img alt="Twitter logo" src={Twitter} height={30}  />
                        </a>
                </div>
              </Grid>
              <Grid item xs={12} sm={4}>
                <div className={classes.links}>
                    <h4>Useful links</h4>
                    <ol className={classes.LinkList}>
                    <li><a style={{color:"#FFF"}} href="https://soundcloud.com/k-brielly">
                          Our Soundcloud
                      </a></li><br/>
                      <li><a style={{color:"#FFF"}} href="https://kintechcybernets.net">
                          Kintech Cybernets
                      </a></li><br/>
                      <li><a style={{color:"#FFF"}} href="https://www.youtube.com/channel/UCXb40x8mVDR5sKteyoHP8Uw">
                          Our YouTube
                      </a></li><br/>
                      <li ><a  style={{color:"#FFF"}} href="https://artists.spotify.com/c/artist/7c6RDQ9fqfTAjjejfwqkA3">
                          Our Spotify
                      </a></li>
                    </ol>
                    <img src={LOGO} alt="K-Brielly logo" height={150} />
                </div>
              </Grid>
            </Grid>
            <Grid item xs={12}>
            <hr></hr>
            <p className={classes.rights}>Copyright &copy; 2020 All Rights Reserved by K-BRIELLY</p>
            </Grid>
      </Grid>
    </div>
  );
}